import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
//import axios from "axios";
import "./EducationDetails.css";
import Select from "react-select";
import { useSearchParams, useLocation } from "react-router-dom";
import { educationDetailsSubmit, getDegreeType, getEmployeeDetailsBasedonEmployeeUniqueeId, getQualifications, getSpecialzation } from "../../../../../../services/employeeCreationService";
import { getAuditLog } from "../../../../../../utils/calculateDaysInMonthUtils";
import ConfirmModal from "../../../../../../components/common/ConfirmModal/ConfirmModal";
import { capitalizeFirstLetter, getFileName, isAlphabet } from "../../../../../../utils/validations";
import { selectStyleDisable, selectStyles } from "../../../../../../assets/Styles/selectStyle";


const EducationDetails = ({ onNext, onPrevious, employeeId }) => {
  const location = useLocation();
  const [hasOtherCertificate, setHasOtherCertificate] = useState(null);
  const [otherCertificate, setOtherCertificate] = useState({
    name: "",
    file: null,
    errors: {},
  });
  const [errors, setErrors] = useState('');
  const [isDirty, setIsDirty] = useState(false);

  const [completed, setCompleted] = useState(false);   // <-- NEW
  const isFieldDisabled = completed;
  // Add a new state at the top with your other useState declarations
  const [isSpecFocused, setIsSpecFocused] = useState(false);
  const [searchParams] = useSearchParams();
  const employeeUniqueId = searchParams.get('employeeUniqueId') || location.state?.applicationId;
  const [educationData, setEducationData] = useState([
    {
      qualifications: "",
      specialization: "",
      institutionName: "",
      degree: "",
      board: "",
      cgpa: "",
      yearOfPassing: "",
      uploadCertificate: null,
      errors: {},
    },
  ]);
  const [degreeOptions, setDegreeOptions] = useState({}); // Changed to object
  const [isQualFocused, setIsQualFocused] = useState(false);
  const [isYearFocused, setIsYearFocused] = useState(false);
  const [focusState, setFocusState] = useState({
    //specialization: false,
    institutionName: false,
    cgpa: false,
  });
  const [yearOptions, setYearOptions] = useState([]);
  const [qualifications, setQualifications] = useState([]);
  const [specialization, setSpecialzation] = useState([]);
  const [isNextEnabled, setIsNextEnabled] = useState(false);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const navigate = useNavigate();
  const [personalInfo, setPersonalInfo] = useState({
    givenName: "",
    surname: "",
    jobPosition: "",
  });
  // Validate forms to enable/disable Next button
  useEffect(() => {
    const allValid = educationData.every((form) => validateForm(form).isValid);
    setIsNextEnabled(allValid);
  }, [educationData]);

  // Fetch qualifications
  useEffect(() => {
    const fetchQualifications = async () => {
      try {
        const data = await getQualifications();
        if (Array.isArray(data)) {
          setQualifications(
            data.map((q) => ({
              value: q.id,
              label: q.qualificationName,
            }))
          );
        } else {
          console.error("Invalid response: qualifications should be an array");
        }
      } catch (err) {
        console.error("Error fetching qualifications:", err);
      }
    };
    fetchQualifications();
  }, []);

  // Fetch year options
  useEffect(() => {
    const currentYear = new Date().getFullYear();
    const years = [];
    for (let y = currentYear; y >= 1950; y--) {
      years.push({ value: y, label: y.toString() });
    }
    setYearOptions(years);
  }, []);

  // Load saved education data from localStorage and re-fetch degree options
  // New useEffect to fetch degrees for initial data
  useEffect(() => {
    if (educationData.length > 0 && qualifications.length > 0) {
      const loadInitialDegrees = async () => {
        const newDegreeOptions = { ...degreeOptions };
        for (let index = 0; index < educationData.length; index++) {
          const form = educationData[index];
          if (form.qualifications) {
            try {
              const qualificationId = form.qualifications;
              const res = await getDegreeType(qualificationId);

              // Use the same logic as above to determine 'degreeArray'
              let degreeArray = [];
              if (Array.isArray(res)) { degreeArray = res; }
              else if (res && Array.isArray(res.data)) { degreeArray = res.data; }
              else if (res && res.degreeTypes && Array.isArray(res.degreeTypes)) { degreeArray = res.degreeTypes; }

              newDegreeOptions[index] = degreeArray.map((d) => ({
                value: d.id,
                label: d.degreeType,
              }));
            } catch (error) {
              console.error(`Error loading initial degrees for index ${index}:`, error);
              newDegreeOptions[index] = [];
            }
          }
        }
        setDegreeOptions(newDegreeOptions);
      };

      loadInitialDegrees();
    }
    // Remove the previous useEffect that called handleQualificationChange in a loop.
    // The previous useEffect should now look only at employeeUniqueId and not call the async function.
  }, [educationData, qualifications]); // Re-run when educationData or qualifications are loaded

  // Specialization  change and fetch 
  // Fetch Specializations
  useEffect(() => {
    const fetchSpecialzation = async () => {
      try {
        const data = await getSpecialzation();
        if (Array.isArray(data)) {
          setSpecialzation(
            data.map((s) => ({
              value: s.id,
              label: s.specializationName,
            }))
          );
        } else {
          console.error("Invalid response: qualifications should be an array");
        }
      } catch (err) {
        console.error("Error fetching qualifications:", err);
      }
    };
    fetchSpecialzation();
  }, []);
  // Handle qualification change and fetch degree types
  const handleQualificationChange = async (index, selected) => {
    const qualificationId = selected?.value || "";
    handleChange(index, "qualifications", qualificationId);
    handleChange(index, "degree", ""); // Reset degree when qualification changes

    if (qualificationId) {
      try {
        const res = await getDegreeType(qualificationId);
        // Assuming 'res' is the data (the array or object containing the array)

        // 1. Determine the actual array of degree objects
        let degreeArray = [];
        if (Array.isArray(res)) {
          // Case 1: Service returns the array directly
          degreeArray = res;
        } else if (res && Array.isArray(res.data)) {
          // Case 2: Service returns an object with a 'data' array (common for custom services)
          degreeArray = res.data;
        } else if (res && res.degreeTypes && Array.isArray(res.degreeTypes)) {
          // Case 3: Service returns an object with a 'degreeTypes' array
          degreeArray = res.degreeTypes;
        }

        let formatted = degreeArray.map((d) => ({
          value: d.id,
          label: d.degreeType,
        }));

        if (formatted.length === 0) {
          console.warn("Fetched data was empty or invalid for formatting:", res);
        }

        setDegreeOptions((prev) => ({
          ...prev,
          [index]: formatted,
        }));

      } catch (error) {
        // ... (existing error handling)
        console.error("Error fetching degree types:", error);
        setDegreeOptions((prev) => ({ ...prev, [index]: [] }));
      }
    } else {
      setDegreeOptions((prev) => ({ ...prev, [index]: [] }));
    }
  };

  // Handle input changes
  const handleChange = (index, field, value) => {
    const updatedForms = [...educationData];
    const currentForm = updatedForms[index];

    // ← FIX: Ensure errors is always an object
    const currentErrors = currentForm.errors || {};

    updatedForms[index] = {
      ...currentForm,
      [field]: value,
      errors: { ...currentErrors, [field]: "" },
    };

    setEducationData(updatedForms);
    // ... rest of localStorage save
  };

  // Handle file changes
  const handleFileChange = (index, e) => {
    const file = e.target.files[0];
    if (file) {
      const updatedForms = [...educationData];
      updatedForms[index] = {
        ...updatedForms[index],
        uploadCertificate: file,
        errors: { ...updatedForms[index].errors, uploadCertificate: "" },
      };
      setEducationData(updatedForms);
      localStorage.setItem(
        "educationData",
        JSON.stringify(
          updatedForms.map((form) => ({
            ...form,
            uploadCertificate: form.uploadCertificate ? { name: form.uploadCertificate.name } : null,
          }))
        )
      );
      setIsDirty(true);
    }


  };

  const validateForm = (form) => {
    const errors = {};
    let isValid = true;

    if (!form.qualifications) {
      errors.qualifications = "Qualification is required.";
      isValid = false;
    }

    if (Number(form.qualifications) !== 1 && !form.degree) {
      errors.degree = "Degree is required.";
      isValid = false;
    }



    return { isValid, errors };
  };

  // Handle adding a new form
  const handleAddForm = (index) => {
    const formToValidate = educationData[index];
    const { isValid, errors } = validateForm(formToValidate);

    const updatedForms = [...educationData];
    updatedForms[index] = { ...updatedForms[index], errors };
    setEducationData(updatedForms);

    if (!isValid) return;

    setEducationData([
      ...educationData,
      {
        qualifications: "",
        specialization: "",
        institutionName: "",
        degree: "",
        board: "",
        cgpa: "",
        yearOfPassing: "",
        uploadCertificate: null,
        errors: {},
      },
    ]);
    setDegreeOptions((prev) => ({ ...prev, [educationData.length]: [] }));
  };


  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate forms
    const updatedForms = educationData.map((form) => {
      const { isValid, errors } = validateForm(form);
      return { ...form, errors };
    });
    setEducationData(updatedForms);

    if (!updatedForms.every((form) => validateForm(form).isValid)) {
      return;
    }

    const fullName = localStorage.getItem("full_name");
    const role = localStorage.getItem("role");
    const employeeId = localStorage.getItem("employeeId");

    const formData = new FormData();

const educationList = educationData.map((form) => {
  const qualId = Number(form.qualifications);
  const isSSC = qualId === 1;

  const payload = {
    ...(form.id ? { id: form.id } : {}),
    qualification: { id: qualId },
    institutionName: form.institutionName,
    gradeOrPercentage: form.cgpa !== "" ? Number(form.cgpa) : null,
    yearOfPassing: form.yearOfPassing ? Number(form.yearOfPassing) : null,
  };

  // Add degree only if not SSC
  if (!isSSC && form.degree) {
    payload.degreeType = { id: Number(form.degree) };
  }

  // Add specialization only if not SSC and selected
  if (!isSSC && form.specialization) {
    payload.specializationId = { id: Number(form.specialization) };
  }

  return payload;
});

    // ✅ Full payload
    const requestPayload = { educationList };
    if (employeeId && role) {
      // requestPayload.auditLog = {
      //   name: fullName,
      //   role,
      //   employeeId,
      // };
      requestPayload.auditLog = getAuditLog();
    }

    // ✅ Append JSON payload
    formData.append("request", JSON.stringify(requestPayload));

    // ✅ Append files
    educationData.forEach((form, index) => {
      if (form.uploadCertificate) {
        formData.append("files", form.uploadCertificate);
      } else {
        formData.append("files", new Blob([]), ""); // placeholder
      }
    });


    if (hasOtherCertificate === "true" && otherCertificate.file) {
      formData.append("files[]", otherCertificate.file);
    }

    try {
      let response;
      const hasExistingId = educationData.some((form) => form.id);

      // 🔹 Same API for create & update in your case
      // response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/education/${employeeUniqueId}`,formData,
      //   { headers: { "Content-Type": "multipart/form-data" } }
      // );
      response = await educationDetailsSubmit(employeeUniqueId, formData);
      console.log("Education submission response:", response.data);

      // 🔹 Save back returned IDs
      if (response.data && response.data.educationList) {
        setEducationData((prev) =>
          prev.map((form, idx) => ({
            ...form,
            id: response.data.educationList[idx]?.id || form.id,
          }))
        );

        localStorage.setItem(
          "educationData",
          JSON.stringify(
            response.data.educationList.map((form) => ({
              ...form,
              uploadCertificate: null, // don’t persist files
            }))
          )
        );
      }

      onNext();
    } catch (error) {
      console.error("Submission error:", {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
      });

      let errorMessage =
        error.response?.data?.message ||
        "Failed to submit education data. Please try again.";

      setEducationData((prev) =>
        prev.map((form) => ({
          ...form,
          errors: { ...form.errors, general: errorMessage },
        }))
      );
    }
  };


  useEffect(() => {
    const fetchApplicationDetails = async () => {
      if (!employeeUniqueId) return;

      try {
        // const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/personal-info/${employeeUniqueId}`);
        // const appData = response.data;
        const appData = await getEmployeeDetailsBasedonEmployeeUniqueeId(employeeUniqueId);
        // Map fetched education details to the form structure
        if (appData.educations && appData.educations.length > 0) {
          const mappedEducation = appData.educations.map((edu) => ({
            id: edu.id || null,
            qualifications: edu.qualification?.id || "",
            degree: edu.degreeType?.id || "",
            specialization: edu.specializationResponse?.id || "",
            institutionName: edu.institutionName || "",
            board: edu.board || "",
            cgpa: edu.gradeOrPercentage || "",
            yearOfPassing: Number(edu.yearOfPassing) || "",
            uploadCertificate: null,
            certificate: edu.certificate || null,
            verified: edu.verified,
            errors: {},
          }));
          setEducationData(mappedEducation);
          // Store the fetched data to compare later
          localStorage.setItem("initialEducationData", JSON.stringify(mappedEducation));
        } else {
          // Initialize empty form if no education details
          setEducationData([
            {
              qualifications: "",
              specialization: "",
              institutionName: "",
              degree: "",
              board: "",
              cgpa: "",
              yearOfPassing: "",
              uploadCertificate: null,
              certificate: null,
              errors: {},
            },
          ]);
          localStorage.setItem("initialEducationData", JSON.stringify([emptyEducationData]));
        }

        // Set personal info
        setPersonalInfo({
          givenName: appData.givenName || appData.employee?.firstName || "",
          surname: appData.surname || appData.employee?.lastName || "",
          jobPosition: appData.employee?.jobPosition || "",
        });
        //setCompleted(appData.completed === true);
        console.log("Fetched application data:", appData);
        setIsDirty(false); // Reset dirty state after fetching
      } catch (error) {
        console.error("Error fetching application data:", error);
      }
    };

    fetchApplicationDetails();
  }, [employeeUniqueId]);

  // Update handlePreviousClick to compare with initial data
  const handlePreviousClick = () => {
    const initialEducationData = JSON.parse(localStorage.getItem("initialEducationData")) || [];

    // Compare current educationData with initialEducationData
    const isFormChanged = educationData.some((form, index) => {
      const initialForm = initialEducationData[index] || emptyEducationData;
      return (
        form.qualifications !== initialForm.qualifications ||
        form.specialization !== initialForm.specialization ||
        form.institutionName !== initialForm.institutionName ||
        form.degree !== initialForm.degree ||
        form.board !== initialForm.board ||
        form.cgpa !== initialForm.cgpa ||
        form.yearOfPassing !== initialForm.yearOfPassing ||
        form.uploadCertificate !== null // Check if a new file was uploaded
      );
    });

    if (isFormChanged) {
      setShowConfirmModal(true);
    } else {
      onPrevious(); // Navigate back directly if no changes
    }
  };

  // Define method outside JSX
  const handleConfirmYes = () => {
    setEducationData({
      qualifications: "",
      specialization: "",
      institutionName: "",
      degree: "",
      board: "",
      cgpa: "",
      yearOfPassing: "",
      uploadCertificate: null,

    });
    setEducationData(emptyEducationData);
    setShowConfirmModal(false);
    onPrevious(); // Navigate back
  };
  const emptyEducationData = {
    qualifications: "",
    specialization: "",
    institutionName: "",
    degree: "",
    board: "",
    cgpa: "",
    yearOfPassing: "",
    uploadCertificate: null,

  };
  // put this inside your component, above return()





  const handleConfirmNo = () => {
    setShowConfirmModal(false);
  };
  const handleRemoveForm = async (indexToRemove) => {
    const recordToDelete = educationData[indexToRemove];

    // If it has an ID from backend → call DELETE API
    if (recordToDelete?.id) {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_BASE_URL}/api/education/${recordToDelete.id}`,
          {
            method: "DELETE",
          }
        );

        if (!response.ok) {
          throw new Error("Failed to delete record from server");
        }

        console.log(`Record ${recordToDelete.id} deleted successfully`);
      } catch (error) {
        console.error("Error deleting education record:", error);
        alert("Failed to delete record from server");
        return; // Stop here if API delete fails
      }
    }

    // Remove from UI after successful API delete or if it's a new unsaved record
    setEducationData((prevData) =>
      prevData.filter((_, index) => index !== indexToRemove)
    );
  };



  return (
    <React.Fragment>
      <div className="educationdetails-container">
        <div className="eductiondetails-box">
          <div className="edudetails-heading"><span className="highlight-label">Temporary ID : </span>
            {employeeUniqueId} - {personalInfo.givenName} {personalInfo.surname} - {personalInfo.jobPosition.designationName}
          </div>
          <h2 className="educationdetails-heading">Educational Details</h2>
          {educationData.map((form, index) => (
            <div key={index} className="education-form">
              <div
                className={`eductiondetails-floating-label-container ${form.qualifications || isQualFocused ? "float-label" : ""
                  }`}
              >
                <Select
                  options={qualifications}
                  value={
                    qualifications.find(
                      (q) => String(q.value) === String(form.qualifications) // match by ID as string
                    ) || null
                  }
                  onChange={(selected) => {
                    handleQualificationChange(index, selected);
                    handleChange(index, "qualifications", selected ? selected.value : "");
                  }}
                  onFocus={() => setIsQualFocused(true)}
                  onBlur={() => setIsQualFocused(false)}
                  placeholder=""
                  isClearable
                  menuPortalTarget={document.body}

                  isDisabled={isFieldDisabled}
                  styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                />
                <label>
                  <span className="required">*</span>Qualification
                </label>

                {form.errors?.qualifications && (
                  <p className="error-message">{form.errors.qualifications}</p>
                )}
                {form.errors?.general && (
                  <p className="error-message">{form.errors.general}</p>
                )}
              </div>
              {Number(form.qualifications) !== 1 && (
                <div className={`eductiondetails-floating-label-container ${form.degree || focusState.degree ? "float-label" : ""}`}>
                  <Select
                    options={degreeOptions[index] || []} // Use index-specific options
                    value={(degreeOptions[index] || []).find((d) => d.value === form.degree) || null}
                    onChange={(selected) => handleChange(index, "degree", selected?.value || "")}
                    onFocus={() => setFocusState((prev) => ({ ...prev, degree: true }))}
                    onBlur={() => setFocusState((prev) => ({ ...prev, degree: false }))}
                    placeholder=""
                    isClearable
                    menuPortalTarget={document.body}

                    isDisabled={isFieldDisabled}
                    styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                  />
                  <label>
                    <span className="required">*</span>Degree / Examination
                  </label>
                  {form.errors?.degree && (
                    <p className="error-message">{form.errors.degree}</p>
                  )}
                </div>
              )}
              {/* <div
                className={`eductiondetails-floating-label-container ${form.specialization || focusState.specialization ? "float-label" : ""
                  }`}
              >
                <label>
                  Specialization
                </label>
                <input
                  type="text"
                  value={form.specialization || ""}
                  onFocus={() => setFocusState((f) => ({ ...f, specialization: true }))}
                  onBlur={() => setFocusState((f) => ({ ...f, specialization: false }))}
                  onChange={(e) => {
                    let value = e.target.value;
                    if (isAlphabet(value)) {
                      value = capitalizeFirstLetter(value);
                      handleChange(index, "specialization", value);
                    }
                  }}
                  placeholder=""
                  disabled={isFieldDisabled}
                />
                {form.errors?.specialization && (
                  <p className="error-message">{form.errors.specialization}</p>
                )}
              </div> */}

              <div
                className={`eductiondetails-floating-label-container ${form.specialization || isSpecFocused ? "float-label" : ""
                  }`}
              >
                <Select
                  options={specialization}
                  value={
                    specialization.find(
                      (s) => String(s.value) === String(form.specialization) // match by ID as string
                    ) || null
                  }
                  onChange={(selected) => {
                    // handleQualificationChange(index, selected);
                    handleChange(index, "specialization", selected ? selected.value : "");
                  }}

                  onFocus={() => setIsSpecFocused(true)}
                  onBlur={() => setIsSpecFocused(false)}
                  placeholder=""
                  isClearable
                  menuPortalTarget={document.body}

                  isDisabled={isFieldDisabled}
                  styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                />
                <label>
                  Specialization
                </label>

                {form.errors?.qualifications && (
                  <p className="error-message">{form.errors.qualifications}</p>
                )}
                {form.errors?.general && (
                  <p className="error-message">{form.errors.general}</p>
                )}
              </div>
              <div className={`eductiondetails-floating-label-container ${form.institutionName || focusState.institutionName ? "float-label" : ""}`}>
                <label>
                  Institution Name
                </label>
                <input
                  type="text"
                  value={form.institutionName || ""}
                  onFocus={() => setFocusState((f) => ({ ...f, institutionName: true }))}
                  onBlur={() => setFocusState((f) => ({ ...f, institutionName: false }))}
                  onChange={(e) => handleChange(index, "institutionName", e.target.value)}
                  placeholder=""
                  disabled={isFieldDisabled}
                />
                {form.errors?.institutionName && (
                  <p className="error-message">{form.errors.institutionName}</p>
                )}
              </div>
              <div
                className={`eductiondetails-floating-label-container ${form.cgpa || focusState.cgpa ? "float-label" : ""}`}>
                <label>Grade / Percentage</label>
                <input
                  type="number"
                  step="0.01"
                  min="0"
                  max="100"
                  value={form.cgpa ?? ""}
                  onFocus={() => setFocusState((f) => ({ ...f, cgpa: true }))}
                  onBlur={() => setFocusState((f) => ({ ...f, cgpa: false }))}
                  onChange={(e) => handleChange(index, "cgpa", parseFloat(e.target.value))}
                  placeholder=""
                  disabled={isFieldDisabled}
                />
                {form.errors?.cgpa && <p className="error-message">{form.errors.cgpa}</p>}
              </div>
              <div
                className={`eductiondetails-floating-label-container ${form.yearOfPassing || isYearFocused ? "float-label" : ""
                  }`}
              >
                <Select
                  options={yearOptions}
                  value={yearOptions.find((opt) => opt.value === form.yearOfPassing) || null}
                  onChange={(selected) => handleChange(index, "yearOfPassing", selected?.value || "")}
                  onFocus={() => setIsYearFocused(true)}
                  onBlur={() => setIsYearFocused(false)}
                  placeholder=""
                  isClearable
                  menuPortalTarget={document.body}

                  isDisabled={isFieldDisabled}
                  styles={isFieldDisabled ? selectStyleDisable : selectStyles}
                />
                <label>
                  Year of Passing
                </label>
                {form.errors?.yearOfPassing && (
                  <p className="error-message">{form.errors.yearOfPassing}</p>
                )}
              </div>
              <div className="eductiondetails-input-containers">
                <label>
                  Upload Certificate
                </label>
                {(() => {
                  // Condition 1: The entire application is completed (isFieldDisabled is true)
                  const isAppCompleted = isFieldDisabled;

                  // Condition 2: The current certificate has been explicitly verified (true)
                  const isCertificateVerified = form.verified === true;

                  // Disable the input ONLY if the app is completed AND the certificate is verified.
                  // If the app is completed but the certificate is NOT verified (false or null), 
                  // the input must remain enabled for the user to upload a correction.
                  const disableFileInput = isAppCompleted && isCertificateVerified;

                  return (
                    <input
                      type="file"
                      name={`uploadCertificate_${index}`}
                      onChange={(e) => handleFileChange(index, e)}
                      // Use the new calculated disableFileInput variable
                      disabled={disableFileInput}
                    />
                  );
                })()}
                {form.uploadCertificate ? (
                  <span className="file-name">{form.uploadCertificate.name}</span>
                ) : (
                  form.certificate && (
                    <span className="file-name">
                      {/* {form.certificate.split('/').pop().split('?')[0]} */}
                     { getFileName(form.certificate)}
                    </span>
                  )
                )}




              </div>

              <div className="educationdetails-input-containers">
                {/* Show "+" only for the last form */}
                {index === educationData.length - 1 && (
                  <button
                    type="button"
                    className="educationdetails-table-btn"
                    onClick={() => handleAddForm(index)}
                    disabled={!validateForm(educationData[index]).isValid}
                  >
                    +
                  </button>
                )}

                {/* Show "–" for all forms except the first */}
                {educationData.length > 1 && (
                  <button
                    type="button"
                    className="educationdetails-table-btn remove-btn"
                    onClick={() => handleRemoveForm(index)}
                    disabled={educationData.length === 1}
                  >
                    –
                  </button>
                )}
              </div>

            </div>
          ))}
          <div className="educationdetails-btns-div">
            <button type="button" className="eductiondetails-btn" onClick={handlePreviousClick}>
              Previous
            </button>
            <button
              type="button"
              className="eductiondetails-btn"
              onClick={handleSubmit}
              disabled={!isNextEnabled}
            >
              Save & Next
            </button>
          </div>
        </div>

        {showConfirmModal && (
          <ConfirmModal
            message="Do you want to clear the form?"
            onConfirm={handleConfirmYes}
            onCancel={handleConfirmNo}
          />
        )}
      </div>
    </React.Fragment>
  );
};

export default EducationDetails;